import React from 'react';
import PropTypes from 'prop-types';
import { Form, ToastContext } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';

import DeletionModal from '../../components/deletionModal';

import UploadFileZone from '../../components/upload/uploadFileZone';

export default function Media({ organization, media, type, updateImage }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);
    const [deletingImage, setDeletingImage] = React.useState(false);

    return (
        <Form.Field>
            <DeletionModal
                onClose={() => setDeletingImage(false)}
                onAccept={() => {
                    setDeletingImage(false);
                    updateImage(null, media, type);
                }}
                objectToDelete={deletingImage}
            />
            <UploadFileZone
                organization={organization}
                onUpload={image => {
                    updateImage(image, media, type);
                }}
                onError={() => toast.error(t('ticket.partners.medias.error.upload'))}
                title={t(`ticket.partners.medias.${type}.label`)}
                labelDropzone={t('ticket.event.dropzone_label')}
                file={media.url}
                onDelete={() => setDeletingImage(true)}
            />
        </Form.Field>
    );
}

Media.propTypes = {
    organization: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    media: PropTypes.object,
    updateImage: PropTypes.func.isRequired
};
